import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import ToastNotification from '../../UiKitComponents/ToastNotification'
import ConfirmationModal from '../../ReusableField/ConfirmationModal'
import { calculateAge } from '../../../constant/constants'
import { closeConfirmationModal } from '../../../redux/actions/confirmationModal'

const PageComponent = (props) => {
  const dispatch = useDispatch()
  const { careReceipients, authorizedPerson, representativePerson } = useSelector(
    (state) => state,
  )
  const confirmationModal = useSelector((state) => state.confirmationModal)
  const toastNotification = useSelector((state) => state.toastNotification)
  const { pathname } = window.location
  const convertToDate = (dateString) => {
    const [day, month, year] = dateString.split('.')
    const date = new Date(year, month - 1, day)
    return date.toString()
  }
  const [windowWidth, setWindowWidth] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })
  const handleResize = () => {
    setWindowWidth({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }
  useEffect(() => {
    window.addEventListener('resize', handleResize)

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  useEffect(() => {
    window.onpopstate = () => {
      dispatch(closeConfirmationModal())
    }
    window.onhashchange = () => {
      dispatch(closeConfirmationModal())
    }
  }, [])
  const footerNull =
    careReceipients.levelOfCare === 'Nein' ||
    careReceipients.levelOfCare === '1' ||
    authorizedPerson.professionalCarer === 'Ja' ||
    authorizedPerson.periodOfCare === 'Unter 6 monate' ||
    pathname === '/chooseData' ||
    pathname === '/summary' ||
    pathname === '/profile' ||
    pathname === '/set-password' ||
    pathname === '/settings' ||
    pathname === '/payment'

  useEffect(() => {}, [careReceipients.levelOfCare])
  return (
    <>
      {windowWidth.width <= 980 && pathname === '/payment' && <Header />}
      {pathname !== '/payment' && <Header />}
      {confirmationModal && <ConfirmationModal {...confirmationModal} />}
      {props.children}
      {/*{footerNull ? null : <Footer/>}*/}
      {footerNull ? null : <Footer />}
      {toastNotification ? <ToastNotification {...toastNotification} /> : []}
    </>
  )
}

export default PageComponent
